import React, { Component } from 'react';

export default class BandcampPlayerLarge extends Component {
  render() {
    const { albumId } = this.props;

    return (
      <div className="BandcampPlayerLarge">
      	<iframe 
          className="lozad"
          style={{border: '0', width: '320px', height: '768px'}} 
          src={`https://bandcamp.com/EmbeddedPlayer/album=` + albumId + `/size=large/bgcol=ffffff/linkcol=0687f5/transparent=true/`} 
          seamless
          >
          <a href="http://moosealmighty.bandcamp.com/album/bound-revolving">Bound &amp; Revolving by Moose Almighty</a>
        </iframe>
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Media/BandcampPlayerLarge/BandcampPlayerLarge.js